import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const defaultNS = "melco-machinestatus-web";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "es", "fr", "it", "nl", "pt", "de"],
    fallbackLng: "en",
    fallbackNS: ["melco-machinestatus-web", "melco-common"],
    detection: { order: ["navigator"], caches: [] },
    ns: ["melco-machinestatus-web", "melco-common"],
    defaultNS,
    debug: true,
    backend: {
      loadPath: "/translations/{{ns}}/{{lng}}.json",
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    returnNull: false,
  });

// Log the detected language
i18n.on("languageChanged", (lng) => {
  console.log("Language changed to:", lng);
});

export default i18n;
